<template>
    <div>
        <el-row >
            <el-col :span="6">
                <span style="font-size:12px;color:rgba(0, 0, 0, 0.7)">说明：该模块配置小程序首页公告信息，最多同时激活3则公告</span>
            </el-col>
            <el-col :span="6">
                <el-button type="primary" icon="el-icon-plus" @click="openDialog()">新增</el-button>
            </el-col>
        </el-row>
        <el-table :data="tableData" style="width: 100%;margin-top:20px" border>
            <el-table-column :resizable="false" type="index" label="序号" width="100" align="center">
                <template slot-scope="scope">{{ scope.$index + 1 + pageSize * (pageNo - 1) }}</template>
            </el-table-column>
            <el-table-column prop="notice" label="公告内容" :resizable="false" align="center"></el-table-column>
            <el-table-column label="操作" :resizable="false" align="center" width="200">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="deleteNotice(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="新增公告" :visible.sync="addDialogVisible" width="33%" :before-close="handleToClose" :close-on-click-modal="false">
            <el-form ref="addForm" :model="addForm" label-width="80px" :rules="rules">
                <el-form-item label="公告内容" prop="notice">
                    <el-input v-model="addForm.notice" placeholder="请输入公告内容"></el-input>
                </el-form-item>
                <div class="dialog-footer">
                    <el-button type="info" @click="handleToClose">取消</el-button>
                    <el-button type="primary" @click="submitForm()">确定</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
      return {
          tableData: [],
          pageNo:1,
          pageSize: 10,
          addDialogVisible: false,
          addForm: {
                notice: ''
          },
          rules: {
                 notice: [
                     { required: true, message: '请输入公告内容', trigger: 'blur' },
                     {max: 30,message: "公告内容不能超过30个字" }
                 ]
        }
      }
    },
    created() {
       this.getNoticeList();
    },
    methods: {
        async getNoticeList(){
            const res = await this.$axios.post('manage/config/getNoticeList')
            if(res.data.code == 0){
                this.tableData = res.data.data
            }else{
                this.$message.error(`${res.data.msg}`);
            }
        },
        async deleteNotice(id) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios
                    .get('manage/config/removeNotice', {
                        params : {
                            id: id
                        }
                    })
                    .then(res => {
                        if (res.data.code == 0) {
                            this.$message.success('删除成功');
                            this.getNoticeList();
                        } else {
                            this.$message.error(res.data.data);
                        }
                    })
                    .catch(() => {
                        this.getNoticeList();
                    });
            });
        },
        openDialog() {
            this.addDialogVisible= true;
        },
        handleToClose() {
            let that = this;
            that.$confirm('确认放弃对当前页面信息的保存吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    that.addDialogVisible = false;
                    that.resetForm()
                })
                .catch(() => {});
            // 重置表单
        },
        resetForm() {
            this.addForm.notice = ''
        },
        submitForm() {
            let that = this;
            that.$refs.addForm.validate(valid => {
                if (valid) {
                    this.$axios
                        .post('manage/config/saveNotice', {
                            notice: this.addForm.notice
                        })
                        .then(res => {
                            if (res.data.code == 0) {
                                that.$message.success('新增成功');
                                that.addDialogVisible = false;
                                that.resetForm();
                                that.getNoticeList()
                            } else {
                                that.$message.error(res.data.data);
                            }
                        });
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        }
    }
}
</script>

<style>
.dialog-footer {
    text-align: right;
}
.el-select {
    width: 100%;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
    border: 1px dashed #d9d9d9;
}
.avatar {
    width: 148px;
    height: 148px;
    display: block;
}

</style>